import Arquivo from "model/arquivo/Arquivo";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useEffect } from "react";
import DocumentoVersaoService from "service/documentos/DocumentoVersaoService";
import FirebasePdfService from "service/FirabasePdfService";

type Props = {
    visible: boolean;
    onHide: () => void;
    arquivo: Arquivo | null;
    arquivoLocal?: any;
}

const documentoVersaoService = new DocumentoVersaoService();
const firebasePdfService = new FirebasePdfService();
export default function ModalDocumentoVisualizarArquivo(props: Props) {
    function renderAnexo() {
        if (props.arquivoLocal) {
            if(props.arquivoLocal.file.type === "application/pdf") {
                let url = URL.createObjectURL(props.arquivoLocal.file);
                return <iframe src={url} style={{ width: '100%', height: '600px', border: 'none' }} title="Visualização do Documento"></iframe>
            } else if (props.arquivoLocal.file.type.startsWith("image/")) {
                return <div style={{ width: '100%', height: 'auto', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <img src={URL.createObjectURL(props.arquivoLocal.file)} alt="Visualização do Documento" style={{ height: "auto", maxHeight: "70vh" }} />
                </div>
            } else {
                return <span style={{fontWeight: 700}}>Esse tipo de arquivo não pode ser mostrado em tela antes de ser enviado para o servidor</span>
            }
        } else if (props.arquivo?.imagem) {
            return <div style={{ width: '100%', height: 'auto', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <img src={props.arquivo?.url} alt="Visualização do Documento" style={{ height: "auto", maxHeight: "70vh" }} />
            </div>
        } else if (props.arquivo?.pdf) {
            return <iframe
                src={firebasePdfService.getPdfUrl(props.arquivo.url)}
                style={{ width: '100%', height: '600px', border: 'none' }}
                title="Visualização do Documento"
            ></iframe>
        } else {
            return <iframe src={`https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(props.arquivo?.url || "")}`} style={{ width: '100%', height: '600px', border: 'none' }} title="Visualização do Documento"></iframe>
        }
    }

    return (
        <>
            <Dialog
                header="Visualizar Documento"
                visible={props.visible}
                baseZIndex={100}
                style={{ width: '80%' }}
                onHide={props.onHide}
                footer={<>
                    <Button label="Fechar" icon="pi pi-times" className="p-button-danger" onClick={props.onHide} />
                </>}
            >
                <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '1rem' }}>
                    {renderAnexo()}
                </div>

            </Dialog>
        </>
    );
}